import React from 'react';
import { renderRichText } from '../utils/rich-text';
import type { Form } from '../interfaces/form.interface';

interface RejectMessageProps {
  configuration: Form;
}

export const RejectMessage: React.FC<RejectMessageProps> = ({ configuration }) => {
  return (
    <div className="space-y-4">
      <div className="text-center">
        {configuration.theme?.content?.paragraphs?.reject?.map((paragraph, index) => (
          <p key={index} style={{ color: configuration.theme?.visual?.textColor || '#333333' }}>
            {renderRichText(paragraph)}
          </p>
        ))}
      </div>
    </div>
  );
};
